<template>
    <div class="online-booking-flow-choices">
        <div class="big-radio-choice flex m-b-10 cursor-pointer" :class="{ 'selected' : !value || value === 'this' }" @click.prevent="$emit('input', 'this')">

            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
                <i v-if="!value || value === 'this'" class="zmdi zmdi-check-circle"></i>
                <i v-else class="zmdi zmdi zmdi-circle-o"></i>
            </div>

            <div class="big-radio-description">
                <b class="m-0 block">
                    <slot name="this-heading">
                        {{ trans(`apps.${feature}.just_one`) }}
                    </slot>
                </b>
                <small class="text-muted">
                    <slot name="this-description">
                        {{ lang.current }}
                    </slot>
                </small>
            </div>
        </div>
        <div class="big-radio-choice flex m-b-10 cursor-pointer " :class="{ 'selected' : value === 'future' }" @click.prevent="$emit('input', 'future')">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
                <i v-if="value === 'future'" class="zmdi zmdi-check-circle"></i>
                <i v-else class="zmdi zmdi zmdi-circle-o"></i>
            </div>

            <div class="big-radio-description">
                <b class="m-0 block">
                    <slot name="future-heading">
                        {{ trans(`apps.${feature}.future`) }}
                    </slot>
                </b>
                <small class="text-muted">
                    <slot name="future-description">
                        {{ lang.future }}
                    </slot>
                </small>
            </div>
        </div>
        <div class="big-radio-choice flex m-b-20 cursor-pointer " :class="{ 'selected' : value === 'all' }" @click.prevent="$emit('input', 'all')">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
                <i v-if="value === 'all'" class="zmdi zmdi-check-circle"></i>
                <i v-else class="zmdi zmdi zmdi-circle-o"></i>
            </div>

            <div class="big-radio-description">
                <b class="m-0 block">
                    <slot name="all-heading">
                        {{ trans(`apps.${feature}.all`) }}
                    </slot>
                </b>
                <small class="text-muted">
                    <slot name="all-description">
                        {{ lang.all }}
                    </slot>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            required: true,
            type: String,
            validator: value => ['update', 'delete', 'move'].includes(value),
        },

        value: {
            required: false,
            type: String,
            default: 'this',
            validator: value => ['this', 'future', 'all'].includes(value),
        },

        feature: {
            required: false,
            type: String,
            default: 'team_meetings',
        }
    },

    emits: ['input'],

    computed: {
        lang() {
            switch (this.type) {
                case 'delete':
                    return {
                        current: this.trans(`apps.${this.feature}.delete_this`),
                        future: this.trans(`apps.${this.feature}.delete_future`),
                        all: this.trans(`apps.${this.feature}.delete_all`),
                    }
                case 'move':
                    return {
                        current: this.trans(`apps.${this.feature}.move_this`),
                        future: this.trans(`apps.${this.feature}.move_future`),
                        all: this.trans(`apps.${this.feature}.move_all`),
                    }
                default:
                    return {
                        current: this.trans(`apps.${this.feature}.update_this`),
                        future: this.trans(`apps.${this.feature}.update_future`),
                        all: this.trans(`apps.${this.feature}.update_all`),
                    }
            }
        },
    },
}
</script>
